import React from 'react'
import { formatCustomerStatus } from '@@partner:helpers/formatters/customer'

import { Tag } from 'rsuite'

export interface CustomerStatusLabelProps {
  status: number
}

export default function CustomerStatusLabel ({
  status
}: CustomerStatusLabelProps) {
  const { label, color = null } = formatCustomerStatus(status)
  return (
    <Tag className="u-status-badge" color={color}>
      {label}
    </Tag>
  )
}
